"use client";

import { useState } from "react";
import Form from "next/form";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { updateCreditLimitAction } from "../actions";
import DialogAlert from "./DialogAlert";
import SubmitButton from "./SubmitButton";
import { UserList } from "./UserList";
import { User } from "@/api/users";

export default function ManageCreditLimitButton({ users }: { users: User[] }) {
  const [open, setOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState<boolean>(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setAlertVisible(false);
    setOpen(false);
  };

  const handleAction = async (formData: FormData) => {
    const result = await updateCreditLimitAction(formData);
    if (result.success) {
      handleClose();
    } else {
      setAlertVisible(true);
    }
  };

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleOpen}>
        Manage Credit Limit
      </Button>
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <Form action={handleAction}>
          <DialogAlert
            message="There was a problem updating credit limits"
            setVisible={setAlertVisible}
            visible={alertVisible}
          />
          <DialogTitle>Manage Credit Limit</DialogTitle>
          <DialogContent>
            <p>This will effect the following users:</p>
            <UserList users={users} />
            {users.map((user) => (
              <input key={user.id} type="hidden" name="ids" value={user.id} />
            ))}
            <TextField
              fullWidth
              label="Credit Limit"
              margin="normal"
              name="credit_limit"
              placeholder="Enter credit limit amount"
              required
              type="number"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="secondary" type="button">
              Cancel
            </Button>
            <SubmitButton label="Update" pendingLabel="Updating..." />
          </DialogActions>
        </Form>
      </Dialog>
    </>
  );
}
